<div class="flex-row column full">
  <div class="flex-row column full row-gap-20 p-20">
    <div class="flex-row align-center column-gap-10">
      <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="close(false)">
        <img class="cursor-pointer" src="assets/new-assets/icons/icon-arrow-back.svg" alt="Go back">
      </button>
      <p class="text-dark fs-20 fw-8 fs-md-16">Edit or delete transaction</p>
    </div>
    <span class="color-secondary fs-md-14">Update equity or mutual fund transactions </span>
  </div>
  <ng-template [ngTemplateOutlet]="allScrips"></ng-template>
  <div class="flex-row align-center content-center column-gap-30 p-15 border-top-1 bg-white">
    <button type="button" class="btn color-blue border-color-DCEBEF text-uppercase fw-7 width-16"
      (click)="close(false)">Cancel</button>
    <button type="button" class="btn btn-primary text-uppercase fw-7 width-16"
      (click)="editTransaction()">update</button>
  </div>
</div>


<ng-template #allScrips>
  <div
    class="flex-row align-center content-between full column-gap-10 row-gap-20 bg-color-F7F8F7 pt-10 pb-10 pr-20 pl-20 color-secondary fw-6 fs-14 d-none-md">
    <div class="width-25-pr">SCRIP</div>
    <div class="flex-row align-center content-between width-50-pr">
      <!-- <div class="width-25-pr text-center">Old QTY</div> -->
      <div class="width-35-pr text-center">New QTY</div>
      <div class="width-50-pr text-center">Price per share</div>
    </div>
    <div class="width-20-pr text-center"></div>
  </div>
  <div class="flex-row column full row-gap-20 p-20 max-height-6-vh overflow-y">
    <div
      class="flex-row align-center content-between full row-gap-20 column-gap-10 column-md pb-15 border-bottom-color-ECF3F5">
      <div class="flex-row align-center width-25-pr full-md content-between column-gap-md-20">
        <div class="flex-row align-center column-gap-10">
          <!-- <div class="img rectangle flex-row"> -->
          <!-- <img class="margin-auto" *ngIf="stocks?.insdivument?.logo" src="{{stockBaseUrl}}{{stocks?.insdivument?.logo}}"alt=""> -->
          <!-- </div> -->
          <p class="fs-14 fw-6 text-dark">{{transaction.tradingSymbol}}</p>
        </div>
        <div class="flex-row align-center column-gap-20 d-none d-flex-md">
          <p class="text-success text-center fs-14 fw-7 ">{{scriptType}}</p>
          <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="deleteTransaction()">
            <img class="cursor-pointer" src="assets/new-assets/icons/icon-remove-circle.svg" alt="Remove">
          </button>
        </div>
      </div>
      <div class="flex-row align-center content-between width-50-pr full-md">
        <!-- <div class="width-25-pr width-md-30-pr align-center flex-row column row-gap-md-10">
          <p class="color-5A627A fs-14 d-none d-block-md">Previous Qty.</p>
          <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6" [formControl]="oldQuantity" type="number">
        </div> -->
        <div class="width-35-pr width-md-30-pr align-center flex-row column row-gap-md-10">
          <p class="color-5A627A fs-14 d-none d-block-md">Current Qty.</p>
          <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6" [formControl]="newQuantity"
            type="number" aria-label="Current Quantity" inputmode="numeric">
        </div>
        <div class="width-50-pr width-md-30-pr align-center flex-row column row-gap-md-10">
          <p class="color-5A627A fs-14 d-none d-block-md">Price per unit</p>
          <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6" [formControl]="currentPrice"
            type="number" aria-label="Current Price" inputmode="numeric">
        </div>
      </div>
      <div class="width-20-pr flex-row align-center column-gap-15 content-between d-none-md">
        <div class="p-10 border-1 width-70-pr border-radius-4">
          <p class="text-success text-center fs-14 fw-7">{{scriptType}}</p>
        </div>
        <!-- <img class="cursor-pointer" src="assets/new-assets/icons/icon-remove-circle.svg" alt="Remove"> -->
      </div>
    </div>
  </div>
</ng-template>